





































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import config from '@/config/index';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');

import { fetchMS } from './fetchMS';
import { AxiosResponse } from 'axios';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    AgGridVue,
    FormFieldsContainer,
    Confirmation,
  },
})
export default class ModalSeries extends Vue {
  @Prop({ required: true, default: [] }) data: any;
  //@Prop({ required: true, default: null }) deviceList!: any;
  @Prop({ required: true, default: null }) funcionalidad!: any;
  //@Prop({ required: true, default: true }) dialog!: boolean;
  dialog: boolean = true;
  showFinalizando: boolean = false;
  texto_finalizando: string = '';
  id_trx: string = null;
  quickSearch: string = '';
  orderList: any;
  intervalFinaliza: any = '';

  dialogPopUp: boolean = false;
  requerimientoSeleccionado: any;

  msgPopUp: string = '';
  titlePopUp: string = '';
  btnTextConfirmation: string = '';
  btnTextCancel: string = '';
  isClose: boolean = true;
  btnIsClose: boolean = false;
  download: boolean = false;

  async handleGridReady(event: GridReadyEvent) {
    this.orderList = await this.getSeries(this.data);
    this.gridApi = event.api;
    this.gridApi.setRowData(this.orderList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleClosedModal(): void {
    this.dialogPopUp = false;
    this.$emit('closeModalSeries');
  }

  handleShowPopUp({ isClose = true }: { isClose?: boolean }) {
    if (!this.orderList.length) {
      this.handleClosedModal();
      return;
    }
    this.isClose = isClose;
    this.dialogPopUp = true;
    if (isClose) {
      this.titlePopUp = 'Confirmación';
      this.msgPopUp =
        'Al cerrar esta ventana toda la información ingresada se perderá. ¿Está seguro que desea cerrar sin guardar?';
      this.btnTextConfirmation = 'No Guardar';
      this.btnTextCancel = 'Continuar';
      return;
    }
    this.titlePopUp = 'Finalizar Requerimiento';
    this.msgPopUp = '¿Está seguro que desea finalizar el requerimiento?';
    this.btnTextConfirmation = 'Confirmar';
    this.btnTextCancel = 'Cancelar';
  }

  popUpOpened(Confirmation: boolean) {
    if (this.isClose && Confirmation) {
      this.handleClosedModal();
    } else if (!this.isClose && Confirmation) {
      this.finalizarRequerimiento();
    }
    this.dialogPopUp = false;
  }

  async intervalFinalizaFx() {
    console.log('intervalFinalizaFx');
    console.log(this.texto_finalizando);
    console.log(this.id_trx);
    let result = await fetchMS({ id_trx: this.id_trx }, 'consultaEstadoTrx');
    console.log(result);
    if (result.data.CODIGO_RESPUESTA == '1') {
      this.texto_finalizando = result.data.MSG_PANTALLA;
      if (result.data.pendiente == 'f') {
        this.texto_finalizando = result.data.content.MENSAJE_RESPUESTA;
        this.showFinalizando = false;
        if (result.data.content.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(result.data.content.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
          this.dialog = false;
          this.$emit('finalizarCompleto');
        } else {
          this.$snotify.error(result.data.content.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
        clearInterval(this.intervalFinaliza);
      }
    } else {
      this.$snotify.error(result.data.MENSAJE_RESPUESTA, { timeout: 3000 });
    }
  }

  async finalizarRequerimiento() {
    try {
      this.loadingService.showLoading(undefined, 'finalizarRequerimiento');
      const body: any = {
        asigcreacion_auto: this.data.asigcreacion_auto,
        asigdeta_finalizado: this.data.asigdeta_finalizado,
        asignumero: this.data.asignumero,
        asigrequerimiento: this.data.asigrequerimiento,
        id_usuario: JSON.parse(window.localStorage.user).id,
        usuariorut: localStorage.getItem('clienteDefecto'),
        modulo: this.funcionalidad,
        data: [...this.orderList],
      };
      const result = await fetchMS(body, 'finalizarRequermiento_back');
      //const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      //const cod: number = parseInt(CODIGO_RESPUESTA);
      //if (cod !== 1) {
      //  throw new Error(MENSAJE_RESPUESTA);
      //}
      //this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
      //this.handleClosedModal();
      console.log(result);
      if (result.data.CODIGO_RESPUESTA == '1') {
        this.showFinalizando = true;
        this.texto_finalizando = result.data.MSG_PANTALLA;
        this.id_trx = result.data.id_trx;

        this.intervalFinaliza = setInterval(this.intervalFinalizaFx, 5000);
      } else {
        this.showFinalizando = false;
        this.$snotify.error(result.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      }

      //showFinalizando: boolean = false;
      //texto_finalizando: string = '';
    } catch (err) {
      console.log(err);
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('finalizarRequerimiento');
    }
  }

  async getSeries(data: any) {
    try {
      this.download = true;
      this.loadingService.showLoading();
      const result: AxiosResponse = await fetchMS(
        {
          tag: 'only_series_preparadas',
          ...data,
        },
        'get_asignacion_seriado_detalle'
      );
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      this.btnIsClose = result.data.data ? false : true;

      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      const { LISTA } = result.data.data;

      return [...LISTA];
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
      } else {
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
      }
      return [];
    } finally {
      this.download = false;
      this.loadingService.hideLoading();
    }
  }

  onModelUpdated(): void {
    if (!this.gridApi) {
      return;
    }
  }

  // Globales
  tabModel: string = 'tab-3';
  muestraBarraBotones: boolean = false;
  registrosAsociar: any = [];
  rowsPerPageItems: any = [];
  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  showTabPerfiles: boolean = true;
  showTabRoles: boolean = true;
  loadingService = new LoadingService();
  paramsExportar: any; //Parametros para Exportar
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;
  nombreModulo: string = '';

  // Controller
  readonly $snotify: Snotify = null;
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';

  // Grilla
  gridApi: GridApi = null;
  columnApi: ColumnApi = null;
  columnDefs: ColDef[] = [];
  agGridUtil: AgGridUtil = null;

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      localeText: {
        noRowsToShow: 'No hay equipos disponibles para mostrar',
      },
      pagination: true,
      paginationPageSize: 10, //Solución Paginación
      cacheBlockSize: 10, //Solución Paginación
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      rowSelection: 'multiple',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onGridSizeChanged: event => event.api.sizeColumnsToFit(),
    };
  }

  private colsGrid(): ColDef[] {
    const columns: { id: string; field: string }[] = [
      {
        id: 'serieactiva_finalizada',
        field: 'Estado Finalización',
      },
      {
        id: 'validauser',
        field: 'Estado Preparación',
      },
      {
        id: 'serienumero',
        field: 'Serie Nro',
      },
      {
        id: 'tipoeq',
        field: 'Tipo de Equipo',
      },

      {
        id: 'serieactivafecha_alta',
        field: 'Fecha de Preparación',
      },
      {
        id: 'modalidad',
        field: 'Modalidad',
      },
      {
        id: 'simserienumero',
        field: 'SIM Número',
      },
      {
        id: 'plataforma',
        field: 'Plataforma',
      },
      {
        id: 'serieactivaplata_ingresada',
        field: 'Estado en Plataforma',
      },
      {
        id: 'serieactivaplata_fecha',
        field: 'Fecha en Plataforma',
      },
      {
        id: 'serieactivaid_dispositivo',
        field: 'ID en Plataforma',
      },
      {
        id: 'serieactivaavl',
        field: 'AVL',
      },
      {
        id: 'epc',
        field: 'EPC',
      },
      {
        id: 'serieactivaobs',
        field: 'Observación',
      },
      {
        id: 'estado_inventario',
        field: 'Estado Inventario',
      },
      {
        id: 'serieactiva_novalido',
        field: 'Estado Devolución',
      },
    ];

    return columns.map(col => {
      let cellRenderer = null;
      if (col.id === 'serieactiva_finalizada') {
        cellRenderer = { cellRenderer: this.getHtmlEstadoFinalizacion };
      }
      if (col.id === 'validauser') {
        cellRenderer = { cellRenderer: this.getHtmlestadopreparacion };
      }
      if (col.id === 'estado_inventario') {
        cellRenderer = { cellRenderer: this.getHtmlEtadoInventario };
      }
      if (col.id === 'serieactiva_novalido') {
        cellRenderer = { cellRenderer: this.getHtmlEstadoDevolucion };
      }

      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: true,
        width: 200,
        minWidth: 200,
        ...cellRenderer,
      };
    });
  }

  getHtmlEstadoFinalizacion(params: any): string {
    if (params.data.serieactiva_finalizada === 'Finalizado') {
      return '<i class="material-icons" title="Finalizado"  style="width: 24px; height: 24px; margin-top: 7%; color: green; border-radius: 50%;">done</i>';
    }
    return '<i class="material-icons" title="Sin Finalizar"  style="width: 24px; height: 24px; margin-top: 7%; color: red; border-radius: 50%;">close</i>';
  }

  getHtmlestadopreparacion(params: any): string {
    if (params.data.estado_preparacion == 'f') {
      return '<i class="material-icons" title="Pendiente"  style="width: 24px; height: 24px; margin-top: 7%;  color:yellow; border-radius: 50%;">pending</i>';
    }
    return '<i class="material-icons" title="Listo"  style="width: 24px; height: 24px; margin-top: 7%; color:green; border-radius: 50%;">done</i>';
  }

  getHtmlEtadoInventario(params: any): string {
    if (params.data.estado_inventario == 'f') {
      return '<i class="material-icons"  title="false" style="width: 24px; height: 24px; margin-top: 7%; background: #FF2626; border-radius: 50%;"></i>';
    }
    return '<i class="material-icons" title="true" style="width: 24px; height: 24px; margin-top: 7%; background: #26FF26; border-radius: 50%;"></i>';
  }

  getHtmlEstadoDevolucion(params: any): string {
    if (params.data.serieactiva_novalido === 't') {
      return '<i class="material-icons" title="Devuelto"  style="width: 24px; height: 24px; margin-top: 7%; color: red; border-radius: 50%;">close</i>';
    }
    return '';
  }
}
